// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"322":"7186e5a6f7ffa0f7","424":"0275e06779bf1de1"}[chunkId] + ".js";
};